module.exports = __webpack_public_path__ + "static/0063-295bc8f60df03c7bd6a427d01ce94015.png";